// extracted by mini-css-extract-plugin
export default {"bubbles":"Bubbles_bubbles__4donE","bubble":"Bubbles_bubble__PJNT9","rise":"Bubbles_rise__TwO66"};